<div class="payment-loading">
    <img src="../../../assets/images/hr-loader.svg" alt="loading indicator">
    <h3>Please Wait</h3>
    <h4>while we get the best offers for you. This may take some time </h4>
    <div class="warning-text">
        <div class="left">
            <span class="ak-info"></span>
        </div>
        <div class="right">
            <h3>Don't refresh the page</h3>
        </div>
    </div>
</div>